import React, { useState } from 'react';
import styled from 'styled-components';
import { CastPage } from './CastPage';
import { DetailHeader } from './DetailHeader';
import { DetailSection } from './DetailSection';
import { SeasonPage } from './SeasonPage';
import { SliderSection } from '../SliderSection';
import StarRating from '../StarRating';
import { Splide, SplideSlide } from '@splidejs/react-splide';
import '@splidejs/splide/dist/css/themes/splide-sea-green.min.css';
import '@splidejs/splide/dist/css/themes/splide-default.min.css';
import { Helmet, HelmetProvider } from 'react-helmet-async';

const BackgroundImage = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-image: url(${props => props.bgImage});
  background-position: center center;
  background-size: cover;
  filter: blur(3px);
  opacity: 0.5;
  z-index: -1;
`;

const Container = styled.div`
  height: 600px;
  width: 100%;
  padding: 0 8%;
  @media (max-width: 768px) {
    height: 100%;
  }
`;

const DataContainer = styled.div`
  height: 100%;
  display: flex;
  @media (max-width: 768px) {
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
`;

const Poster = styled.div`
  width: 405px;
  height: 600px;
  background: url(${props => props.posterImage}) no-repeat center center;
  background-size: cover;
  border-radius: 5px;
  transition: 0.2s linear;
  @media (max-width: 768px) {
    width: 170px;
    height: 250px;
  }
`;

const Content = styled.div`
  width: 70%;
  height: 100%;
  padding: 50px;
  @media (max-width: 768px) {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 25px;
  }
`;

const TitleContainer = styled.div`
  display: flex;
  align-items: center;
`;

const Title = styled.div`
  font-size: 24px;
  margin-right: 8px;
  @media (max-width: 768px) {
    font-size: 18px;
  }
`;

const Subtitle = styled.div`
  font-size: 13px;
  margin-top: 15px;
  opacity: 0.8;
`;

const Items = styled.div`
  @media (max-width: 768px) {
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    font-size: 14px;
  }
`;

const Item = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  margin-top: 15px;
  &:last-of-type {
    margin-top: 25px;
    font-size: 15px;
    opacity: 0.7;
    line-height: 1.7;
    width: 90%;
  }
  @media (max-width: 768px) {
    display: flex;
    justify-content: space-around;
    text-align: center;
    &:last-of-type {
      width: 100%;
      font-size: 13px;
    }
  }
`;

const ItemTitle = styled.div`
  width: 20%;
`;

const ItemData = styled.span`
  width: 85%;
`;

const Button = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 5px;
  width: 75px;
  height: 20px;
  font-weight: 500;
  background-color: ${props => (props.isMovie ? '#E2B616' : '#40407a')};
  color: ${props => (props.isMovie ? 'black' : '   ')};
  font-size: 14px;
`;

const SplideContainer = styled.div`
  padding: 25px 0;
`;

const SplideIframe = styled.iframe`
  width: 450px;
  height: 280px;
  @media (max-width: 768px) {
    width: 250px;
  }
`;

const RecommendCotainer = styled.div`
  padding: 25px 0;
`;

const RecommentImageContainer = styled.div`
  width: 185px;
  height: 300px;
`;

const RecommendImage = styled.img`
  width: 100%;
  max-width: 185px;
  height: 100%;
  background: url(${props => props.bgUrl}) no-repeat center center;
  background-size: cover;
  transition: 0.2s linear;
  border-radius: 15px;

  @media (max-width: 768px) {
    width: 150px;
    height: 225px;
  }
`;

const RecommendTitle = styled.div`
  margin-top: 5px;
`;

const RecommendSubTitle = styled.div`
  position: absolute;
  bottom: 5px;
  left: 5px;
  display: flex;
  flex-direction: column;
  line-height: 1.1;
`;

const RecommendRating = styled.div``;

const RecommendDate = styled.div``;

const Bar = styled.div`
  width: 100%;
  height: 3px;
  background-color: #95a5a6;
  opacity: 0.2;
  margin: 20px 0;
`;

const PageLink = styled.a``;

export const Detail = ({
  title,
  tagline,
  runtime,
  date,
  genres,
  backgroundImage,
  poster,
  imdb,
  overview,
  video,
  voteAverage,
  countrie,
  isMovie,
  seasons,
  homepage,
  movieCredits,
  tvCredits,
  movieRecommend,
  tvRecommend
}) => {
  const [home, setHome] = useState(true);
  const [cast, setCast] = useState(false);
  const [season, setSeason] = useState(false);

  return (
    <>
      <HelmetProvider>
        <Helmet>
          <title>{title} - ScFlix</title>
        </Helmet>
      </HelmetProvider>
      <DetailHeader
        isMovie={isMovie}
        setHome={setHome}
        setCast={setCast}
        setSeason={setSeason}
      />
      <Container>
        <BackgroundImage
          bgImage={`https://image.tmdb.org/t/p/original/${backgroundImage}`}
        />
        <DataContainer>
          <Poster
            posterImage={`https://image.tmdb.org/t/p/original/${poster}`}
          />
          {home && (
            <Content>
              <TitleContainer>
                <Title>{title}</Title>
                {isMovie ? (
                  <a
                    href={`https://www.imdb.com/title/${imdb}`}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <Button isMovie={true}>IMDB</Button>
                  </a>
                ) : (
                  <a
                    href={`${homepage}`}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <Button isMovie={false}>Hompage</Button>
                  </a>
                )}
              </TitleContainer>
              <Subtitle>{tagline}</Subtitle>
              <Items>
                <Item>
                  <ItemTitle>개봉</ItemTitle>
                  <ItemData>{date}</ItemData>
                </Item>
                <Item>
                  <ItemTitle>국가</ItemTitle>
                  <ItemData>{countrie && countrie}</ItemData>
                </Item>
                <Item>
                  <ItemTitle>시간</ItemTitle>
                  <ItemData>{runtime} min</ItemData>
                </Item>
                <Item>
                  <ItemTitle>평점</ItemTitle>
                  <ItemData>
                    <StarRating voteAverage={voteAverage} /> {voteAverage}/10{' '}
                  </ItemData>
                </Item>
                <Item>
                  <ItemTitle>장르</ItemTitle>
                  <ItemData>
                    {genres &&
                      genres.map((genre, i) =>
                        i === genres.length - 1
                          ? genre.name
                          : `${genre.name} / `
                      )}
                  </ItemData>
                </Item>

                <Item>{overview ? overview : 'None'}</Item>
              </Items>
            </Content>
          )}
          {cast && (
            <Content>
              <DetailSection title="출연진">
                {isMovie
                  ? movieCredits &&
                    movieCredits.map(
                      (credit, index) =>
                        index < 10 && (
                          <CastPage
                            key={credit.id}
                            character={credit.character}
                            profile={credit.profile_path}
                            name={
                              credit.name ? credit.name : credit.original_name
                            }
                          />
                        )
                    )
                  : tvCredits &&
                    tvCredits.map(
                      (credit, index) =>
                        index < 10 && (
                          <CastPage
                            key={credit.id}
                            character={credit.character}
                            profile={credit.profile_path}
                            name={
                              credit.name ? credit.name : credit.original_name
                            }
                          />
                        )
                    )}
              </DetailSection>
            </Content>
          )}
          {season && isMovie === false && (
            <Content>
              <DetailSection title={'시즌 정보'}>
                {seasons &&
                  seasons.map(season => (
                    <SeasonPage
                      key={season.id}
                      date={season.air_date}
                      name={season.name}
                      poster={season.poster_path}
                    />
                  ))}
              </DetailSection>
            </Content>
          )}
        </DataContainer>
      </Container>

      <SplideContainer>
        {video && video.length > 0 && (
          <>
            <Bar />
            <SliderSection title="예고편">
              <Splide
                options={{
                  rewind: true,
                  perPage: 3,
                  perMove: 1,
                  cover: true,
                  autoWidth: true,
                  gap: '1rem'
                }}
              >
                {video.map((videos, index) => (
                  <SplideSlide key={index}>
                    <SplideIframe
                      src={`https://www.youtube.com/embed/${videos.key}`}
                      width="420"
                      height="280"
                      frameborder="0"
                      allow="autoplay; fullscreen"
                    />
                  </SplideSlide>
                ))}
              </Splide>
            </SliderSection>
          </>
        )}
      </SplideContainer>

      <RecommendCotainer>
        {movieRecommend && movieRecommend.length > 0 && isMovie === true && (
          <>
            <Bar />
            <SliderSection title="비슷한 영화">
              <Splide
                options={{
                  rewind: true,
                  cover: true,
                  gap: '1rem',
                  autoWidth: true,
                  perPage: 7,
                  perMove: 1,
                  border: false
                }}
              >
                {movieRecommend.map((movie, index) => (
                  <SplideSlide key={index}>
                    <PageLink href={`/movie/${movie.id}`}>
                      <RecommentImageContainer>
                        <RecommendImage
                          bgUrl={`https://image.tmdb.org/t/p/original/${movie.poster_path}`}
                        />
                        <RecommendSubTitle>
                          <RecommendTitle>
                            {movie.title
                              ? movie.title.length > 15
                                ? `${movie.title.substring(0, 15)}...`
                                : movie.title
                              : movie.original_title.length > 15
                              ? `${movie.original_title.substring(0, 15)}...`
                              : movie.original_title}
                          </RecommendTitle>
                          <RecommendRating>
                            <StarRating voteAverage={movie.vote_average} />
                            {String(
                              movie.vote_average && movie.vote_average
                            ).substring(0, 3)}
                            /10
                          </RecommendRating>
                          <RecommendDate>
                            {movie.release_date &&
                              movie.release_date.substring(0, 4)}
                          </RecommendDate>
                        </RecommendSubTitle>
                      </RecommentImageContainer>
                    </PageLink>
                  </SplideSlide>
                ))}
              </Splide>
            </SliderSection>
          </>
        )}
      </RecommendCotainer>

      <RecommendCotainer>
        {tvRecommend && tvRecommend.length > 0 && isMovie === false && (
          <>
            <Bar />
            <SliderSection title="비슷한 프로그램">
              <Splide
                options={{
                  rewind: true,
                  cover: true,
                  gap: '1rem',
                  autoWidth: true,
                  perPage: 7,
                  perMove: 1
                }}
              >
                {tvRecommend.map((tv, index) => (
                  <SplideSlide key={index}>
                    <PageLink href={`/tv/${tv.id}`}>
                      <RecommentImageContainer>
                        <RecommendImage
                          bgUrl={`https://image.tmdb.org/t/p/original/${tv.poster_path}`}
                        />
                        <RecommendSubTitle>
                          <RecommendTitle>
                            {tv.name
                              ? tv.name.length > 19
                                ? `${tv.name.substring(0, 19)}...`
                                : tv.name
                              : tv.original_name.length > 19
                              ? `${tv.original_name.substring(0, 19)}...`
                              : tv.original_name}
                          </RecommendTitle>
                          <RecommendRating>
                            <StarRating voteAverage={tv.vote_average} />
                            {String(
                              tv.vote_average && tv.vote_average
                            ).substring(0, 3)}
                            /10
                          </RecommendRating>
                          <RecommendDate>
                            {tv.release_date && tv.release_date.substring(0, 4)}
                          </RecommendDate>
                        </RecommendSubTitle>
                      </RecommentImageContainer>
                    </PageLink>
                  </SplideSlide>
                ))}
              </Splide>
            </SliderSection>
          </>
        )}
      </RecommendCotainer>
    </>
  );
};
